import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import React, { FC } from 'react';

import AppError from '../AppError';

import App from './App';

const AppBoundary: FC = () => (
  <ErrorBoundary ErrorComponent={AppError} name="App">
    <App />
  </ErrorBoundary>
);

export default AppBoundary;
